import { makeStyles } from '@material-ui/core';
import { createStyles } from '@material-ui/core/styles';
import { colorsPalette } from '../../../theme';

const useStyles = makeStyles(() =>
  createStyles({
    wrapper: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: 6,
      background: colorsPalette.white,
      opacity: 0.07,
      width: '100%',
      zIndex: 5,
    },
    line: {
      position: 'absolute',
      bottom: 0,
      left: 0,
      height: 6,
      transition: 'width .5s',
      background: colorsPalette.blueProgressBar,
      zIndex: 6,
    },
    tooltip: {
      '&:before': {
        display: 'none',
      },
    },
  }),
);

export default useStyles;
